import { isNumber, isDigit, isDate, isBoolean } from '@/utils/is'

export const toNumber = (v: any): number => {
  if (isBoolean(v)) return v ? 1 : 0
  if (isNumber(v)) return v

  if (isDate(v)) return v.getTime()

  if (typeof v === 'string') {
    if (v.endsWith('%')) return parseFloat(v.replace('%', ''))
    if (v.endsWith('px')) return parseFloat(v.replace('px', ''))

    if (isDigit(v[0]) && isDigit(v[v.length - 1])) return parseFloat(v)

    let buff = ''
    for (let i = 0; i < v.length; i++) {
      const c = v[i]
      if (!isDigit(c)) continue
      buff += c
    }
    return parseFloat(buff)
  }

  return 0
}
